import productReducer from "./productReducer";

export const productReducers = {
  product: productReducer,
};
